module.exports = __webpack_public_path__ + "img/rmb-logo.04bd3a48.png";